<template>
	<div class="box" v-if="showTip">
		<top-nav ref="nav" :showBack="false" bgColor="#F6F6FB"><span class="color_back">投保确认书</span></top-nav>
		<template v-if="!pageLoading && !errorMsg">
			<div class="card color_active">
				<div class="tip_title">温馨提示：</div>
				<div class="text_indent">
					请您仔细阅读保障内容及条款，确认信息无误后，再行支付，本保险产品由《{{ insurerFullName }}》承保，由北京赛福哈博保险经纪有限公司提供销售和协助理赔等间接服务，投保前请阅读
					<a class="link" v-if="docToConsumerLink" :href="docToConsumerLink" target="_blank">《客户告知书》</a>
					<span class="color_main" v-else @click="notification && (docShow = true)">《客户告知书》</span>。
				</div>
				<div class="tip">为维护您的权益，您在投保确认页面的操作将会记录和保存。</div>
			</div>
			<div class="card">
				<div class="tip_title">商品信息：</div>
				<div class="row">
					<div class="row_title">商品名称：</div>
					<div>{{ insMasterProductInfoVo.insProductName }}</div>
				</div>
				<div class="row">
					<div class="row_title">计划名称：</div>
					<div>{{ insMasterProductInfoVo.comboName }}</div>
				</div>
			</div>
			<div class="card">
				<div class="tip_title">保障内容：</div>
				<div v-for="(item, index) in insMasterContentInfoVos" :key="index">
					<div class="row">
						<div class="row_title max_w">{{ item.contentName }}</div>
						<div>{{ item.price }}</div>
					</div>
					<div class="remark">{{ item.contentRemark }}</div>
				</div>
			</div>
			<div class="card">
				<div class="tip_title">投保信息：</div>
				<div v-for="(item, index) in insMasterBillInfoVos" :key="item.billCode" :class="index < insMasterBillInfoVos.length - 1 ? 'row_box' : ''">
					<div :class="['row', index > 0 ? 'pt_2' : '']">
						<div class="row_title">订单号：</div>
						<div class="row_content">{{ item.billCode }}</div>
					</div>
					<div class="row">
						<div class="row_title">投保人数：</div>
						<div v-if="insureType == 2">{{ item.assuredNum }}人</div>
						<div v-else>{{ assuredList.length }}人</div>
					</div>
					<div class="row" v-if="item.insureType == 2 || (item.insureType === 1 && item.billState != 4 && item.billState != 5)">
						<div class="row_title">保障期限：</div>
						<div class="row_content">{{ item.enableDate }}<span v-if="getActualShow(item)">(以实际出单时间为准)</span> ~ {{ item.disEnableDate }}</div>
					</div>
					<div class="row">
						<div class="row_title">保障天数：</div>
						<div>{{ getDays(item) }}天</div>
					</div>
					<div class="row" v-if="item?.remark">
						<div class="row_title">活动备注：</div>
						<div>{{ item.remark }}</div>
					</div>
					<div class="row">
						<div class="row_title">总保费：</div>
						<div class="color_red">{{ item.premium }}元</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="tip_title">投保人信息：</div>
				<div class="row">
					<div class="row_title">姓名：</div>
					<div>{{ insMasterInsureInfoVo.insName }}</div>
				</div>
				<div class="row">
					<div class="row_title">证件号：</div>
					<div>{{ insMasterInsureInfoVo.insCredentials }}</div>
				</div>
			</div>

			<div class="pb_10">
				<div class="card">
					<div class="tip_title">被保险人名单（共{{ assuredList.length }}人）：</div>
					<table style="width: 100%; text-align: center; border-collapse: collapse; border-color: #eee; margin-top: 0.2rem" border="1">
						<thead>
							<tr>
								<th>姓名</th>
								<th>证件号码</th>
								<th>保费</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item,index) in assuredList" :key="index">
								<td>{{ item.name }}</td>
								<td>{{ !item.eyeShow ? setEncrypt(item.certificateContent) : item.certificateContent }}<van-icon @click="handleEye(item)" name="eye-o" class="ml_4" v-if="!item.eyeShow" /></td>
								<td>{{ item.premium }}元</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="tip_copyright" >本系统已获软件著作权，受《中华人民共和国著作权法》和《计算机软件保护条例》的保护，未经许可请勿擅自使用、复制、传播软件。</div>

			</div>
			<div class="tip_copyright" v-if="!(insMasterBillInfoVos[0]?.billState == 2 && insMasterBillInfoVos[0]?.payState == 0)">本系统已获软件著作权，受《中华人民共和国著作权法》和《计算机软件保护条例》的保护，未经许可请勿擅自使用、复制、传播软件。</div>


			<div class="p_f" v-if="insMasterBillInfoVos[0]?.billState == 2 && insMasterBillInfoVos[0]?.payState == 0">
				<clauseInfo ref="clauseInfo" :information="information" />
				<div>
					<div class="sginature">手写签名</div>
					<div class="img_sign" @click="handleSignature">
						<img :src="imgUrl" v-if="imgUrl" />
						<div v-else><span class="click_text">点击</span>此处签名</div>
					</div>
				</div>
				<div class="flex_center">
					<van-button type="primary" class="bg_main" @click="handlePay" :loading="btnLoading">确认无误，去支付</van-button>
				</div>
			</div>
			<div v-else class="info_tip">
				<div>{{ insMasterBillInfoVos[0]?.payState == 0 ? '订单未支付' : '订单已支付' }}</div>
			</div>
		</template>
		<template v-else>
			<van-loading v-if="!errorMsg" vertical class="loading"> 加载中...</van-loading>
			<div v-else class="error_msg">{{ errorMsg }}</div>
		</template>

		<!-- 签名 -->
		<signature-pad v-if="showSignature" class="signature" @cancel="signatureCancel" @agree="signatureAgree"></signature-pad>
		<!-- 客户告知书 -->
		<bottomInfoPop :show="docShow" title="客户告知书" :content="notification" @change="docShow = false" />
	</div>
	<div v-else class="weChat_warning"><h4 v-text="weChatWarningText"></h4></div>
</template>

<script>
import clauseInfo from './clauseInfo.vue';
import signaturePad from './signaturePad.vue';
import { Button, Loading, Toast, Icon } from 'vant';
import { loginNoPwd, productDetail, getBillInfo } from '@/request/api';
import { http_getInsCustomerPayArguByOutBillId, http_selectInsMasterBillDetails, http_updateInsCustomerPay, http_getAllAssuredInfoByBillId, http_uploadSignatureFile } from '@/request/zhifu';
import moment from 'moment';
import { getInsuerInfo, porductClause } from '@/request/api';
import { http_getProductConfig, http_getProductComboConfig } from '@/request/insureV2';
import Mtils from 'mtils';

export default {
	name: 'confirmBook',
	components: {
		clauseInfo,
		signaturePad,
		[Button.name]: Button,
		[Loading.name]: Loading,
		[Toast.name]: Toast,
		[Icon.name]: Icon,
	},
	data() {
		return {
			imgUrl: '',
			showSignature: false,
			file: null,
			docShow: false,
			billId: '',
			userDesc: '',
			userId: '',
			insMasterProductInfoVo: {},
			insMasterBillInfoVos: [],
			insMasterInsureInfoVo: {},
			assuredList: [],
			version: '0',
			proId: '',
			comboId: '',
			docToConsumerLink: '', //客户告知书链接
			notification: '', //客户告知书内容，
			insurerFullName: '', //保险公司名称
			insMasterContentInfoVos: [],
			information: {},
			btnLoading: false,
			showTip: false,
			billState: {
				1: '订单待核保',
				2: '订单待支付',
				3: '订单已支付',
				4: '订单已承保',
				5: '订单已退保',
				7: '订单正在出单',
				9: '订单已失效',
			},
			pageLoading: true,
			billInfo: {},
			insureType: '',
			errorMsg: '',
			allBiiIds:'',
			weChatWarningText: '请在微信/支付宝打开',
		};
	},
	computed: {
		totalPrice() {
			return this.insMasterBillInfoVos
				.reduce(function (pre, cur) {
					return pre + cur.premium;
				}, 0)
				.toFixed(2);
		},
	},

	watch: {
		$route: {
			handler: function (val) {
				this.env = this.$base.getEnv();
				this.weChatWarningText = '请在微信/支付宝打开';
				if (this.isWechatPC()) {
					this.weChatWarningText = '请使用手机端微信打开';
					this.showTip = false;
					return false;
				}
				if (this.env !== 'wx' && this.env !== 'zfb' && this.$base.isDev()) {
					this.showTip = false;
					return false;
				}
				this.showTip = true;
				let params = val.query;
				if (!params.billId) {
					return false;
				}
				this.getOrderId();
			},
			immediate: true,
		},
	},
	methods: {
		isWechatPC() {
			return this.env === 'wx' && !this.$base.isMobile();
		},

		//获取订单id
		getOrderId() {
			this.pageLoading = true;
			localStorage.setItem('backUrl', window.location.href);
			http_getInsCustomerPayArguByOutBillId(this.$route.query.billId)
				.then(res => {
					this.billId = res.billId;
					this.version = res.versions;
					this.proId = res.proId;
					this.comboId = res.comboId;
					this.insureType = res.insureType;
					localStorage.setItem('bookBillId', res.billId);
					this.userDesc = res.userDesc;
					this.login().then(res => {
						if (this.insureType == 1) {
							this.getOrderDetailOne();
						} else {
							this.getOrderDetail();
						}
						this.getAssured();
						this.getCustomerContent();
						this.getProductCaseV2();
					});
				})
				.catch(err => {
					this.pageLoading = false;
					this.errorMsg = err.message;
				});
		},

		//获取订单详情拆单
		getOrderDetail() {
			http_selectInsMasterBillDetails(this.billId)
				.then(res => {
					this.insMasterProductInfoVo = res.insMasterProductInfoVo;
					this.insMasterInsureInfoVo = res.insMasterInsureInfoVo;
					this.insMasterBillInfoVos = res.insMasterBillInfoVos;
					this.allBiiIds = res.insMasterBillInfoVos.map(item => item.billId).join(",");
					this.insMasterContentInfoVos = res.insMasterContentInfoVos;
					this.$store.commit('set_billId', this.allBiiIds);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},

		//不拆单
		getOrderDetailOne() {
			getBillInfo(this.billId)
				.then(res => {
					this.insMasterProductInfoVo = { ...res.billInfo, comboName: res.comboName };
					this.insMasterInsureInfoVo = res.billInsure;
					this.insMasterContentInfoVos = res.productContentList;
					this.insMasterBillInfoVos = [res.billInfo];
					this.allBiiIds = res.billInfo.billId;
					this.$store.commit('set_billId', this.allBiiIds);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},

		//被保险人
		getAssured() {
			http_getAllAssuredInfoByBillId(this.billId).then(res => {
				this.assuredList = res.map(item => ({ ...item, eyeShow: false }));
			});
		},

		login() {
			return new Promise(resolve => {
				loginNoPwd(this.userDesc).then(res => {
					this.userId = res.userInfo.id;
					bookKhs.start(this.userId);
					resolve();
				});
			});
		},

		// 取消签名
		signatureCancel() {
			this.showSignature = false;
		},

		// 确定并新增签名
		signatureAgree(data) {
			this.imgUrl = data.src;
			this.file = data.file;
			this.showSignature = false;
		},

		handleSignature() {
			this.showSignature = true;
		},

		//客户告知书
		handleDoc() {
			this.docShow = true;
		},

		handlePay() {
			const result = this.$refs.clauseInfo.getResult();
			if (!result) {
				return;
			}
			if (!this.file) {
				Toast('请签名');
				return false;
			}
			let data = new FormData();
			data.append('file', this.file);
			this.btnLoading = true;
			http_uploadSignatureFile(data)
				.then(async urls => {
					this.btnLoading = true;
					//更新签名
					await http_updateInsCustomerPay({ outBillId: this.$route.query.billId, signatureUrl: urls });
					this.$router.push({
						name: 'bookPay',
						params: {
							isRedict: false,
						},
					});
				})
				.finally(() => {
					this.btnLoading = false;
				});
		},

		//获取客户告知书
		getCustomerContent() {
			getInsuerInfo(this.proId, { comboId: this.comboId, backInsureFlag: 1 }).then(res => {
				if (res.bookList) {
					let bookList = res.bookList.filter(item => item.docType === '03');
					if (bookList.length) {
						this.docToConsumerLink = res.productFileServer + bookList[0].docLink;
					}
				}
				if (!this.docToConsumerLink) {
					this.notification = res.product.notification;
				}
				this.insurerFullName = res.insurer.insurerFullName;
			});
		},

		getDays(item) {
			const start = moment(item.enableDate);
			const end = moment(item.disEnableDate);
			return end.diff(start, 'days') + 1;
		},

		getActualShow(item) {
			return moment().format('YYYY-MM-DD') == moment(item.enableDate).format('YYYY-MM-DD') && item.billState == 2 && item.payState == 0;
		},

		//获取投保须知
		getProductCaseV2() {
			if (this.version == 1) {
				http_getProductConfig({ proId: this.proId }).then(res => {
					//免责内容
					this.information.preventDuty = res.insProductInformation2Vo.preventDuty;
					// 被保险人同意声明
					this.information.insuredDeclare = res.insProductInformation2Vo.f2FixedInfo;
					// 投保须知
					this.information.insuranceTip = res.insProductInformation2Vo.hint;
					http_getProductComboConfig({ proId: this.proId, comboId: this.comboId }).then(res => {
						if (res.insInsureNotesVoList.length > 0) {
							this.information.insuranceTip = res.insInsureNotesVoList;
						}
					});
					//投保声明
					this.information.f1FixedInfo = res.insProductInformation2Vo.f1FixedInfo;
					//个人信息保护政策
					this.information.f3FixedInfo = res.insProductInformation2Vo.f3FixedInfo;
				});
			} else {
				productDetail(this.proId).then(res => {
					//投保须知
					this.information.insuranceTip = res.information.insuranceTip || res.information.hint;
					//免责内容
					this.information.preventDuty = res.information.preventDuty;
					//被保人同意声明
					this.information.insuredDeclare = res.information.insuredDeclare;
					//投保声明
					this.information.f1FixedInfo = res.product.insuranceDeclare;
					//个人信息保护政策
					this.information.f3FixedInfo = res.product.protectionPolicy;
				});
			}
			//保险条款
			porductClause(this.proId, { comboId: this.comboId }).then(res => {
				this.information.mainClausesList = res.mainClausesList?.map(item => {
					return {
						...item,
						link: res.productFileServer + item.docLink,
					};
				});

				this.information.additionClausesList = res.additionClausesList?.map(item => {
					return {
						...item,
						link: res.productFileServer + item.docLink,
					};
				});
			});
		},

		// 证件号脱敏
		setEncrypt(idNumber) {
			let desensitizedIdNumber = idNumber;
			if (idNumber && Mtils.validation.isIdCard(idNumber)) {
				const pattern = /(\d{4})\d+(\d{3})/; // 匹配身份证号码的前四位和后三位
				const replacement = '$1*********$2'; // 替换为前四位+星号+后三位
				desensitizedIdNumber = idNumber.replace(pattern, replacement);
			} else {
				const firstPart = idNumber.substring(0, 2);
				const lastPart = idNumber.substring(5);
				desensitizedIdNumber = `${firstPart}***${lastPart}`;
			}
			return desensitizedIdNumber;
		},

		handleEye(item) {
			this.assuredList.forEach(i => {
				i.eyeShow = false;
				if (i.certificateContent === item.certificateContent) {
					i.eyeShow = true;
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.box {
	height: 100vh;
	padding: 0 0.1rem;
	background-color: #f9faff;
	line-height: 0.46rem;
	position: relative;
}

.card {
	font-size: 0.25rem;
	background-color: #fff;
	margin-top: 0.2rem;
	padding: 0.2rem;
	border-radius: 0.1rem;
	box-shadow: 0rem 0.04rem 0.16rem 0rem rgba(0, 0, 0, 0.1);
}

.color_active {
	background-color: #f1f6fc;
}

.color_back {
	color: $font_color_main;
}

.color_main {
	color: $color_main;
}

.tip_title {
	font-size: 0.28rem;
	font-weight: bold;
}

.tip {
	color: $font_color_info;
	margin-top: 0.2rem;
}

.text_indent {
	text-indent: 0.56rem;
}

.row {
	display: flex;
	justify-content: space-between;
	align-items: baseline;
}
.row_content {
	text-align: right;
	flex: 1;
	word-break: break-all;
}

.row_title {
	min-width: 100px;
	margin-top: 0.1rem;
}

.remark {
	color: $danger;
	font-size: 0.24rem;
}

.pb_10 {
	padding-bottom: 36vh;
}

.p_f {
	position: fixed;
	bottom: 0;
	left: 0;
	background-color: #fff;
	padding: 0.4rem 0.2rem;
	box-shadow: 0rem 0.04rem 0.2rem 0rem rgba(0, 0, 0, 0.2);
}

.img_sign {
	margin-top: 0.2rem;
	font-size: 0.3rem;
	background-color: #f5f5f5;
	width: 100%;
	height: 1.5rem;
	text-align: center;
	line-height: 1.5rem;
	color: $b_font_color_info;
	img {
		height: 100%;
	}
	.click_text {
		font-weight: bold;
		color: #000;
	}
}
.show_signature {
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	box-sizing: border-box;
}

.flex_center {
	display: flex;
	justify-content: center;
	margin-top: 0.4rem;
}

.bg_main {
	background-color: $color_main;
	border-color: $color_main;
}

.color_red {
	color: $danger;
}

.max_w {
	max-width: 68vw;
}

.link {
	color: $color_main;
}

.info_tip {
	color: $danger;
	font-size: 0.4rem;
	text-align: center;
	position: fixed;
	bottom: 0;
	left: 0;
	background-color: #fff;
	padding: 0.4rem 0;
	width: 100%;
	box-shadow: 0rem 0.04rem 0.2rem 0rem rgba(0, 0, 0, 0.2);
}

.loading {
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 0.26rem;
}

.row_box {
	border-bottom: solid 1px #eee;
	padding-bottom: 0.2rem;
}

.pt_2 {
	padding-top: 0.1rem;
}

.sginature {
	font-size: 0.26rem;
}

.error_msg {
	font-size: 0.26rem;
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.ml_4 {
	margin-left: 0.1rem;
}
</style>
